import { takeLatest, call, put, select } from "redux-saga/effects";
import {
  USER_PASSWORD_CHANGE_REQUEST,
  userPasswordChanged,
  userPasswordChangeError,
} from "../../actions/users";
import { role as roleSelector, ADMIN } from "../../selectors/auth";
import scChangePassword from "../../../../../backend/oncall/administration/users/change-password";
import partnerChangePassword from "../../../../../backend/oncall/partners/users/change-password";

const changePassword = function*(action) {
  try {
    const role = yield select(roleSelector);
    const changePassword =
      role === ADMIN ? scChangePassword : partnerChangePassword;
    yield call(
      changePassword,
      action.payload.username,
      action.payload.password,
    );
    yield put(userPasswordChanged());
  } catch (error) {
    yield put(userPasswordChangeError(error.message));
  }
};

export default function*() {
  //noinspection JSCheckFunctionSignatures
  yield takeLatest(USER_PASSWORD_CHANGE_REQUEST, changePassword);
}



// WEBPACK FOOTER //
// ./src/sc/ui/sites/oncall/sagas/users/request-change-password.js